<template lang="pug">
yz-dialog(v-model="showDialog" max-width="496" persistent scrollable)
  yz-card
    yz-dialog-normal-header(title="View reservations & pre-orders" @close="close")
    div.pa-6
      p.yz-medium-body-sm.text-neutral-700.mb-0 Select which items to add to this visit's treatment plan.
      div.d-flex.flex-column.mt-4(style="gap: 12px;")
        template(v-for="item in reservations")
          yz-card.cursor-pointer(:key="'r-'+item.id" :color="isSelected(item, 'reservation') ? 'neutral-200' : 'neutral-100'" :border-color="isSelected(item, 'reservation') ? 'yz-neutral-400' : 'yz-neutral-300'" outlined @click.native="toggleSelection(item, 'reservation')")
            div.d-flex.px-4.py-3(style="gap: 16px;")
              yz-checkbox(:value="isSelected(item, 'reservation')" @input="toggleSelection(item, 'reservation')")
              div.flex-grow-1
                div.yz-heading-9.text-neutral-700 Reservation \#{{ item.rid }}
                template(v-for="product in getProducts(item)")
                  div.d-flex.yz-regular-body-sm.text-neutral-700(:key="product.id || product.product_name" style="gap: 8px;")
                    span {{ product.name || product.product_name }}
                    span x{{ product.quantity }}
        template(v-for="item in preorders")
          yz-card.cursor-pointer(:key="'p-'+item.id" :color="isSelected(item, 'preorder') ? 'neutral-200' : 'neutral-100'" :border-color="isSelected(item, 'preorder') ? 'yz-neutral-400' : 'yz-neutral-300'" outlined @click.native="toggleSelection(item, 'preorder')")
            div.d-flex.px-4.py-3(style="gap: 16px;")
              yz-checkbox(:value="isSelected(item, 'preorder')" @input="toggleSelection(item, 'preorder')")
              div.flex-grow-1
                div.yz-heading-9.text-neutral-700 Pre-order \#{{ item.rid }}
                template(v-for="product in getProducts(item)")
                  div.d-flex.yz-regular-body-sm.text-neutral-700(:key="product.id || product.product_name" style="gap: 8px;")
                    span {{ product.name || product.product_name }}
                    span x{{ product.quantity }}
    yz-dialog-normal-actions(save-label="Add to treatment plan" :disable-save="selectedItems.length === 0" @cancel="close" @save="confirm")
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    reservations: {
      type: Array,
      default: () => []
    },
    preorders: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selectedItems: []
    }
  },
  computed: {
    showDialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    }
  },
  methods: {
    isSelected (item, type) {
      return this.selectedItems.some(s => s.id === item.id && s.type === type)
    },
    toggleSelection (item, type) {
      const index = this.selectedItems.findIndex(s => s.id === item.id && s.type === type)
      if (index >= 0) {
        this.selectedItems.splice(index, 1)
      } else {
        this.selectedItems.push({ id: item.id, type })
      }
    },
    getProducts (item) {
      return item.items || item.products || []
    },
    confirm () {
      this.$emit('confirm', [...this.selectedItems])
      this.selectedItems = []
      this.showDialog = false
    },
    close () {
      this.showDialog = false
    }
  }
}
</script>
